import React from 'react';
import {
  Image,
  PageContent,
  Title4,
  TextLarge,
  SecondaryButton,
  ListBasic,
  ListItemBasic,
  Link,
} from '@hz-design-system/web-ui';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { trackGAEvent } from '../../../utils/gaTracking';
import SellBlock from '../../SellBlock/components/SellBlock';
import PageBackground from '../../PageBackground/components/PageBackground';
import { EnvironmentProvider } from '../../../contexts/EnvironmentContext';

import Classes from './SellPageContent.scss';
import { TEnvConfigCars } from 'types/TServerContext';
import carsLocations from '../../../../../../content/carsContent/locations.json';

type TSellPageContentProps = {
  environment: TEnvConfigCars;
  appState: any;
};

const SellPageContent = ({ environment, appState }: TSellPageContentProps) => {
  const { t } = useI18nContext();
  const {
    links: { imagesSources },
  } = environment;
  const { location } = appState;

  return (
    <EnvironmentProvider value={environment}>
      <section className="Page-section Page-section--full-width">
        <PageBackground />
        <PageContent className={Classes.intentContent}>
          <section className={Classes.sellSection}>
            <h1 className="hz-Title hz-Title--title4 sectionHeader Page-title">
              {location ? t('cars.page.sell.location.h1', { location: location.name }) : t('page.title.sell.cars')}
            </h1>
            <SellBlock withLicensePlateField={appState.withLicensePlateField} />
          </section>
          <section className="PageContent-card PageContent-offset">
            <div className={Classes.contentCard}>
              <div className={Classes.contentBody}>
                <Title4 utilities={['marginBottomS']}>{t('sell.content.cars.title')}</Title4>
                <TextLarge utilities={['marginBottomXxs']}>{t('sell.content.cars.body1')}</TextLarge>
                <TextLarge utilities={['marginBottomL']}>{t('sell.content.cars.body2')}</TextLarge>
                <SecondaryButton
                  as="a"
                  href="/plaats/91"
                  onClick={() => {
                    trackGAEvent('placeAdButtonClicked', 'article');
                  }}
                >
                  {t('cars.sell.place_ad_button2')}
                </SecondaryButton>
              </div>
              <div className={Classes.contentImage}>
                {imagesSources && Boolean(imagesSources?.length) && (
                  <Image
                    src={imagesSources[0]}
                    srcSet={`${imagesSources[0]} 1x, ${imagesSources[1]} 2x`}
                    alt=""
                    loading="lazy"
                    fetchpriority="low"
                    decoding="async"
                    //@ts-expect-error -- DS issue
                    aspectRatio=""
                    fit
                  />
                )}
              </div>
            </div>
          </section>
          {!location && (
            <section className="PageContent-card PageContent-offset">
              <Title4 as="h2" utilities={['marginBottomS']}>
                {t('cars.sell.locations.title')}
              </Title4>
              <ListBasic>
                {carsLocations.map(({ slug, name }) => (
                  <ListItemBasic key={slug}>
                    <Link href={`/cp/91/auto-verkopen/${slug}/`}>
                      {t('cars.sell.locations.label', { location: name })}
                    </Link>
                  </ListItemBasic>
                ))}
              </ListBasic>
            </section>
          )}
        </PageContent>
      </section>
    </EnvironmentProvider>
  );
};

export default SellPageContent;
